var map = {
	"./1280px-Saint-Gobain_logo.svg.png": 4369,
	"./2560px-Onida_Electronics.svg.png": 350,
	"./Benchmark.jpg": 3772,
	"./DSV_Logo.png": 9318,
	"./Digital globe.jpg": 2798,
	"./Ekart-logo.png": 8472,
	"./FM_logistic.png": 5545,
	"./Final1.jpg": 5056,
	"./GlobeIcon": 1577,
	"./GlobeIcon.js": 1577,
	"./Jyothy_Labs_Log0.png": 2922,
	"./LN-favicon.png": 4060,
	"./Maersk_Group_Logo.svg": 5320,
	"./Multimodal.jpg": 2935,
	"./Pernod_Ricard_logo_2019.svg": 7926,
	"./RCI.png": 4571,
	"./RightPartner3.jpg": 3814,
	"./SCC.png": 9824,
	"./Skechers-Logo.png": 2835,
	"./Sundrop_logo.png": 5236,
	"./TCI_freight.png": 3813,
	"./Zydus-wellness-logo.png": 4128,
	"./abr.png": 240,
	"./avg.jfif": 6091,
	"./bajaj_electricals_logo1.png": 8740,
	"./baskins.png": 6906,
	"./bidirectional.jpg": 84,
	"./bosch.png": 5208,
	"./ceat_tyres_logo.jpg": 9386,
	"./cjdarcl.png": 9764,
	"./dhl-logo.jpg": 5649,
	"./ellipsis.gif": 2787,
	"./express-roadways.png": 3670,
	"./file-types/csv.png": 6494,
	"./file-types/excel.png": 299,
	"./file-types/img.png": 3047,
	"./file-types/invalid.png": 6755,
	"./file-types/pdf.png": 5508,
	"./file-types/ppt.png": 5130,
	"./file-types/txt.png": 5718,
	"./file-types/word.png": 1676,
	"./glasswing.png": 7796,
	"./globe.png": 3838,
	"./google-calendar-logo.svg": 5335,
	"./hb_1.jpg": 9635,
	"./hector-beverages-removebg-cropped.png": 6701,
	"./hidromas_logo.jpg": 4074,
	"./icons8-auction-100.png": 7365,
	"./icons8-change-user-80.png": 9887,
	"./icons8-combo-chart-100.png": 6723,
	"./icons8-financial-analytics-96.png": 2704,
	"./icons8-road-80.png": 8727,
	"./icons8-sell-80.png": 6553,
	"./icons8-truck-64.png": 7706,
	"./icsLogo.svg": 1127,
	"./jyothy.jpg": 2862,
	"./kimbal_logo.jpg": 7361,
	"./kuehne-nagel.png": 1271,
	"./laptop.PNG": 816,
	"./location_dashboard.jpg": 1389,
	"./logo-lorri.png": 1595,
	"./logo-lorri_backup.png": 1006,
	"./logo3.png": 869,
	"./myTransporter-banner.jpg": 2250,
	"./outlookLogo.svg": 1249,
	"./paperboat.jpeg": 818,
	"./perfetti.png": 7874,
	"./plus-icon.svg": 5083,
	"./png.jpg": 6816,
	"./schreider_dynamix-logo-removebg-preview.png": 4168,
	"./search-glass.jpg": 8022,
	"./shahways.png": 4855,
	"./shell.jpg": 951,
	"./shell.svg": 2227,
	"./shell_new.png": 4508,
	"./smt-new.png": 6504,
	"./tick.gif": 581,
	"./transporter.jpg": 255,
	"./transporter_logo.png": 9513,
	"./varuna-removebg-preview.png": 4379,
	"./vredestein_logo_2.jpg": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9481;